module.exports = __webpack_public_path__ + "static/media/best_me_2.1fe5c51b.jpg";